
import PortfolioIcon from '@/components/header/icons/PortfolioIcon';
import SandboxIcon from '@/components/header/icons/SandboxIcon';
import MarketIcon from '@/components/header/icons/MarketIcon';
import FinAgentIcon from '@/components/header/icons/FinAgentIcon';
import subscriptionConstants from '@/constants/subscription.constants';

const { subscribeProductKeys, subscriptionPlans } = subscriptionConstants;

export default {
    name: 'PageNavigation',

    components: {
        PortfolioIcon,
        SandboxIcon,
        MarketIcon,
        FinAgentIcon,
    },

    computed: {
        isLoggedIn() {
            return !!this.$store.state.account.user
        },
        isSubscribedFinAgent() {
            return this.isLoggedIn && this.$store.state.account.subscribedProductIds?.includes(subscribeProductKeys.finAgent);
        },
        finAgentLink() {
            if (this.isSubscribedFinAgent) {
                return {
                    path: this.$getTranslatedRoutePath('/fin-agent/'),
                };
            }

            return {
                name: this.$getTranslatedRouteName('subscription'),
                params: { plan: subscriptionPlans.ai }
            };
        },
        pageConfigurations() {
            const locale = this.$store.state.preferences.locale
            const pages = [
                {
                    displayedText: this.$t('components.pageNavigation.portfolio', {}, locale),
                    targetRoute: this.$getTranslatedRoutePath('/finance/dashboard/'),
                    routePathKey: 'finance',
                    iconComponent: 'PortfolioIcon',
                },
                {
                    displayedText: this.$t('components.pageNavigation.sandbox', {}, locale),
                    targetRoute: this.$getTranslatedRoutePath('/sandbox/dashboard/'),
                    routePathKey: 'sandbox',
                    iconComponent: 'SandboxIcon',
                },
                {
                    displayedText: this.$t('components.pageNavigation.marketAnalysis', {}, locale),
                    targetRoute: this.$getTranslatedRoutePath('/market-analysis/'),
                    routePathKey: 'market-analysis',
                    isPublic: true,
                    iconComponent: 'MarketIcon',
                },
                {
                    displayedText: 'finAgent',
                    targetRoute: this.finAgentLink,
                    routePathKey: 'fin-agent',
                    iconComponent: 'FinAgentIcon',
                },
            ]
            return pages.filter(p => this.isLoggedIn || p.isPublic)
        }
    },
    methods: {
        isSelectedPage(routePathKey) {
            const currentRoutePath = this.$route.fullPath
            const translatedRoutePathKey =  this.$getTranslatedRoutePath(`/${routePathKey}/`)
            if (currentRoutePath?.startsWith(translatedRoutePathKey)) {
                return true
            }

            return false
        },
    }
}
